module.exports = __webpack_public_path__ + "static/media/filterIconDashbaord.2ecd154f.png";